import { DateTime, Duration, Settings } from 'luxon';
import { defineStore } from 'pinia';
import { ref, watch } from 'vue';
import { useAccountStore } from './accountStore';

// Pay attention where you import this store, because it will udate it's value continuosly
export const useDateTimeStore = defineStore('dateTime', () => {
  const currentDateTime = ref<DateTime>();
  let diffToServerInMilliseconds = Duration.fromMillis(0);
  let interval: number;

  const accountStore = useAccountStore();

  // create new Datetime Object to reflect timezone- and language-changes
  watch([() => accountStore.timezone, () => accountStore.language], () => updateDateTime());

  function updateDateTime() {
    currentDateTime.value = DateTime.now().plus(diffToServerInMilliseconds);
    Settings.now = () => Date.now() + diffToServerInMilliseconds.toMillis();
  }

  function setServerTime(dateTime: DateTime) {
    window.clearInterval(interval);
    diffToServerInMilliseconds = dateTime.diffNow();
    updateDateTime();
    interval = window.setInterval(updateDateTime, 1000);
  }

  function setServerTimeFromResponse(response?: Response) {
    const serverTime = response?.headers.get('date');

    if (serverTime) {
      setServerTime(DateTime.fromHTTP(serverTime));
    }
  }

  return {
    setServerTime,
    setServerTimeFromResponse,
    currentDateTime,
  };
});
